import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';

@Component({
  selector: 'document-viewer',
  templateUrl: './document-viewer.component.html',
  styleUrls: ['./document-viewer.component.scss']
})
export class DocumentViewerComponent implements OnInit, OnChanges {
  @Input() url!: string;
  pdfUrl: SafeResourceUrl = '';

  constructor(private sanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    this.updatePdfUrl();

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['url'] && changes['url'].currentValue) {
      this.updatePdfUrl();
    }
  }

  private updatePdfUrl(): void {
    if (this.url) {
      let cleanUrl = this.url.replace(/\\/g, '');
      if (cleanUrl.includes('checkout') || cleanUrl.includes('payment')) {
        this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(cleanUrl);
        return;
      } else {
        if(this.isPdfUrl(cleanUrl)) {
          cleanUrl = `https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(cleanUrl)}`
        }
        this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(cleanUrl);
      }
    }
  }

  private isPdfUrl(url: string): boolean {
    // Remover parámetros de query
    const urlWithoutParams = url.split('?')[0];
    return urlWithoutParams.toLowerCase().endsWith('.pdf');
  }
}
